import NR1DashboardsHub from "@/pages/NR1DashboardsHub";

export default function DashboardsHubRH() {
  return <NR1DashboardsHub forcedVariant="rh" />;
}
